import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useParams, useRouteMatch, Link, useHistory, Route} from 'react-router-dom'
import MapInEventDetail from './map_in_event_detail'

function EventDetail(){
    const [event, setEvent] = useState();
    const [openingdayElement, setOpeningdayElement] = useState();
    const [closingdayElement, setClosingdayElement] = useState();
    let {id} = useParams();

    useEffect(()=>{
        getEvent()
    }, [id])

    const history = useHistory();
    const sameday = <p className='date_in_detail'>{openingdayElement}</p>
    const differentday =<p className='date_in_detail'>{openingdayElement} - {closingdayElement}</p>


    function getEvent(){
        axios.get(`/api/get_event/${id}`)
        .then(eventDataFromMongo=>{
            setEvent(eventDataFromMongo.data)
            setOpeningdayElement(eventDataFromMongo.data.modifyOpnday);
            setClosingdayElement(eventDataFromMongo.data.modifyClsday);
            
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const digital_tag = 
    <p>Digital</p>

    const cancel_tag = 
    <p>Cancel</p>

    const postponed_tag = 
    <p>Postponed</p>

    const free_admission_tag = 
    <p>Free Admission</p>

    const recommendation_tag = 
    <p>Recommendation</p>

    return(
        <div className='event_detail'>
            {(event)?<div>
             <div className='tag_in_event_detail'>
             {(event.stetus =='digital')? digital_tag :''}
             {(event.stetus =='cancel')?cancel_tag :''}
             {(event.stetus =='postponed')?postponed_tag :''}
             {(event.isFreeAdmission =='Yes')?free_admission_tag :''}
             {(event.isRecommendation =='Yes')?recommendation_tag :''}
            </div>
            <h2>{event.name}</h2>
        
            

            <div className='detail-flex'>
            <p className='detail-left'>Venue</p>
            <p id='detail-right'>{event.venue}</p>
            </div>

            <div className='detail-flex'>
            <p className='detail-left'>Address</p>
            <div className='address-wrapper'>
            <p id='detail-address1'>{event.address1}</p>
            <p id='detail-address2'>{event.address2}</p>
            </div>
            </div>

            <div className='detail-flex'>
            <p className='detail-left'>Date</p>
            <div id='detail-right'>{event.sameday=='Yes'? sameday:differentday}</div>
            </div>

            <div className='detail-flex'>
            <p className='detail-left'>Tickets</p>
            <p className='detail-right'>{event.tickets}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Web-Site</p>
            <p className='detail-right'><a href={event.website}>{event.name}</a></p>
            </div>

            </div>:''}

            <Route><MapInEventDetail/></Route>
        </div>
    )
};

export default EventDetail;